import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

export const BadgeContainer = styled.span`
  color: var(--neutral-800);
  display: inline-flex;
  align-items: center;

  ${({ text }) =>
    text &&
    css`
      & i {
        margin-right: 4px;
      }
    `}

  ${(props) => {
    let height = 28;
    let textSize = 100;
    const borderWidth = 1;
    let padding = '0 0.75rem';
    if (props.size === 'sm') {
      textSize = 80;
      height = 20;
      padding = '0 0.5rem';
    }
    return css`
      height: ${height}px;
      line-height: ${height}px;
      padding: ${padding};
      ${mixin.text({ size: textSize, strong: true })}
      border-radius: ${height / 2}px;
      ${mixin.border({ width: borderWidth, color: 'neutral', level: 300 })}
      ${props.onClick ? 'cursor: pointer;' : ''}
    `;
  }}
  ${(props) => {
    const { color } = props;
    let colorLevel = 300;
    if (props.badgeStyle === 'inverted') {
      colorLevel = 700;
      if (['aqua', 'neutral'].includes(color)) {
        colorLevel = 800;
      } else if (
        [
          'magenta',
          'blue',
          'orange',
          'red',
          'informational',
          'caution',
          'danger',
        ].includes(color)
      ) {
        colorLevel = 600;
      }
      return css`
        background-color: var(--${color}-${colorLevel});
        border-color: var(--${color}-${colorLevel});
        color: var(--neutral-10);
        & i {
          color: var(--${color}-300);
        }
      `;
    }
    if (props.badgeStyle === 'outline') {
      colorLevel = 300;
      if (['aqua'].includes(color)) {
        colorLevel = 600;
      } else if (['magenta'].includes(color)) {
        colorLevel = 700;
      } else if (['purple'].includes(color)) {
        colorLevel = 400;
      } else if (['neutral', 'teal'].includes(color)) {
        colorLevel = 500;
      }
      return css`
        background-color: transparent;
        border-color: var(--${color}-${colorLevel});
        color: var(--${color}-800);
        & i {
          color: var(--${color}-${colorLevel});
        }
      `;
    }
    let iconLevel = 500;
    if (color === 'yellow') {
      iconLevel = 600;
    }
    return css`
      background-color: var(--${color}-200);
      border-color: var(--${color}-200);
      color: var(--${color}-800);
      & i {
        color: var(--${color}-${iconLevel});
      }
    `;
  }}
`;

export const BadgeText = styled.span``;
